$(document).on('click', '.header__bar__toggle', function () {
  // toggle collapse
  $('.collapse').addClass('active');
  $('html').addClass('no-scroll');
});

$(document).on('click', '.collapse__close', function () {
  // toggle collapse
  $('.collapse').removeClass('active');
  $('html').removeClass('no-scroll');
});
